import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import Header from "../layouts/Header";
import PageDescription from "../components/About/PageDescription";
import VisionMission from "../components/About/VisionMission";
import ValuesCulture from "../components/About/ValuesCulture";
import LeaderShip from "../components/About/LeaderShip";
import OurPartners from "../components/About/OurPartners";
import OurArticle from "../components/Home/OurArticle";
import JoinOurTeam from "../components/Home/JoinOurTeam";
import Footer from "../layouts/Footer";
import { motion } from "motion/react";
import { Helmet } from "react-helmet";
import TechAbility from "../components/About/TechAbility";

const About = () => {
  const location = useLocation();
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1)); // Remove #
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="about-page" id="volto">
        <Header mode="light" />
        <PageBanner
          type={"about"}
          smallHeader="About US"
          header={"Built to Make an Impact"}
          descrption={
            "Your trusted partner in growth and transformation, guiding you toward success with innovative solutions and strategic insights."
          }
        />
        <PageDescription />
        <VisionMission />
        <ValuesCulture />
        <LeaderShip />
        {/* <OurPartners /> */}
        <TechAbility />
        <OurArticle />
        <JoinOurTeam image={"/images/join-our-team.webp"} />
        <Footer />
      </div>
    </motion.div>
  );
};

export default About;
